module.exports = __webpack_public_path__ + "static/media/headway-5QgIuuBxKwM-unsplash.545fbb11.jpg";